import { render, staticRenderFns } from "./RetractCard.vue?vue&type=template&id=80e0943a&"
import script from "./RetractCard.vue?vue&type=script&lang=ts&"
export * from "./RetractCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports